import React, { PropTypes, Component } from 'react';
import idx from 'idx';
import FocusGroupTabs from 'focus_groups/containers/tabs';
import { LoadingIndicator } from 'common/components/preloader';
import Meta from 'project/containers/meta';
import ToggleGroupButton from 'focus_groups/containers/toggle_group_button';
import Share from 'focus_groups/containers/share';
import Upgrade from 'focus_groups/containers/upgrade';

export default class View extends Component {
  constructor(props) {
    super(props);
    this.state = { isVoting: false };
  }

  componentWillMount() {
    this.props.fetch();
  }

  componentWillReceiveProps(nextProps) {
    const { params } = this.props;
    const curGroupId = idx(params, _ => _.focusGroupId);
    const nextGroupId = idx(nextProps, _ => _.params.focusGroupId);
    if (curGroupId !== nextGroupId) {
      nextProps.fetch();
    }
  }

  render() {
    const { viewState, children } = this.props;
    const group = idx(viewState, _ => _.currentGroup);

    if (viewState.isFetching || !group) {
      return (<LoadingIndicator />);
    }

    const totalVotes = group.revisions.reduce((mem, revision) => (
      Object.keys(revision.votes).length + mem
    ), 0);

    return (
      <div>
        <Meta title="Focus Groups" />
        <div className="focus-group-stats-container">
          <div className="row align-center focus-group-stats">
            <div className="columns small-6 medium-4">
              <span className="stat-label">Group Status</span>
              <div className="stat-value">{group.status}</div>
            </div>
            <div className="columns small-5 medium-4">
              <span className="stat-label">Participants</span>
              <div className="stat-value">{group.participants.length}</div>
            </div>
            <div className="columns small-5 medium-4">
              <span className="stat-label">Total Votes</span>
              <div className="stat-value">{totalVotes}</div>
            </div>
            <div className="columns small-16 medium-4 align-middle">
              <ToggleGroupButton />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="columns small-16 large-12">
            <h3 className="focus-group-name">{group.name}</h3>
            <div className="focus-group-tabs">
              <FocusGroupTabs />
              { children }
            </div>
          </div>
          <div className="columns small-16 large-4">
            <Share />
            <Upgrade />
          </div>
        </div>
      </div>
    );
  }
}

View.propTypes = {
  fetch: PropTypes.func.isRequired,
  viewState: PropTypes.shape({
    isFetching: PropTypes.bool,
    currentGroup: PropTypes.object,
  }),
  children: PropTypes.any,
};



// WEBPACK FOOTER //
// ./focus_groups/components/view.jsx